var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseCell',{attrs:{"align":_vm.align}},[_c('InstrumentPrice',{attrs:{"price":_vm.price,"price-width":"100%","percentual":_vm.percentual,"percentual-width":"75%","size":"small","align":_vm.align,"enable-toggle-money":_vm.enableToggleMoney}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }